module.exports = __webpack_public_path__ + "static/TangleTower1-1908f2024284e35665a23a040276d906.png";